import Vue from 'vue';
import Entry from './entry';
import loading from '@directives/loading';

Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.directive('loading', loading);

new Vue({
  render: h => h(Entry),
}).$mount('.ph-app__container');
